import {
  Box,
  Container,
  Grid,
  GridItem,
  Heading,
  Text,
  Link,
  Stack,
  HStack,
  Button,
  Image,
  Flex,
  Spacer,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
} from '@chakra-ui/react'
import { FiDownload } from 'react-icons/fi'
import { AiOutlineCloudDownload } from 'react-icons/ai'
import { Header } from '../modules/merchant/Header'
import PayLeafNavbar from '../components/PayLeafNavbar'

const faq = [
  {
    question: 'What is a payment solution?',
    answer:
      'We provide you with software that makes it easy for you to accept mobile payments over the Solana network. Without ever touching your funds.',
  },
  {
    question: 'What do I need to start?',
    answer: (
      <Text as='span'>
        You need a Solana crypto wallet. <br />
        With it, you will have complete control over your own funds. Create one,
        sign up at our website with it, and starting taking payments easily.
      </Text>
    ),
  },
  {
    question: 'How does it work?',
    answer: (
      <Text as='span'>
        After signing up, you will receive a link to your own POS website. On
        this website, you can can receive a payment in 3 easy steps.
        <br />
        1. Input the amount your customer should pay
        <br />
        2. Let him scan the QR code.
        <br />
        3. Wait a few seconds for the transaction to confirm.
      </Text>
    ),
  },
  {
    question: 'How can I pay?',
    answer: (
      <Text as='span'>
        As a user it's simple. You'll need the mobile crypto wallet called
        Phantom and enough PUFF, Solana or USDC in your wallet for the
        transaction.
        <br />
        1. Scan the QR code with the built in scanner
        <br />
        2. Confirm the transaction
        <br />
        3. Enjoy your goods
      </Text>
    ),
  },
  {
    question: 'How do I benefit as a Stoned Ape holder?',
    answer: (
      <Text as='span'>
        1. <b>PUFF</b> should <b>become the No1 cannabis-focused Token</b>.
        Instead of just us accepting PUFF, we will make sure the whole industry
        accepts it.
        <br />
        <br />
        2. We will <b>grow this payment platform with the community</b> and make
        sure all of our <b>holders benefit</b>! Our <b>ambassador program</b>{' '}
        also makes it possible for you to earn passive income by bringing
        PayLeaf to a dispensary or other retail location near you.
      </Text>
    ),
  },
  {
    question: 'Why join?',
    answer: (
      <Text as='span'>
        PayLeaf will <b>super charge</b> your operation and improve multiple day
        to day tasks.
        <br />
        We make a range of things easier for you:
        <br />- You don't need to manage cash.
        <br />- You can easily retarget your customers with ads, without even
        knowing their names.
        <br />- You save on fees in comparison to credit/debit cards.
        <br />
        <br />
        On top of that, you are adopting a global cannabis payment solution in
        web3 for broader acceptance of cannabis.
      </Text>
    ),
  },
  {
    question: 'Why should I care as a dispensary?',
    answer: (
      <Text as='span'>
        Peer-to-peer crypto payments in the Cannabis space solve the problems
        limiting the utilization of credit cards, but provide a safer mechanism
        of managing funds vs cash.
      </Text>
    ),
  },
  {
    question: 'Cryptos are volatile. Is there any risk?',
    answer: (
      <Text as='span'>
        Through our automatic swap system, you are able to automatically swap
        any token you receive to a stablecoin like USDC with stable value
        (pegged by the USD)
        <br />
        You can then transfer USDC to any crypto exchange and convert it to USD.
      </Text>
    ),
  },
]

export default function Merchant() {
  return (
    <Box
      minHeight={'100vh'}
      background='#F3F3F5'
      color='#262626'
      display={'flex'}
      flexDirection='column'
      justifyContent={'space-between'}
      fontFamily='Inter'
    >
      <Container maxW={'78.5rem'} pt='2rem' px='1rem' pb='3rem'>
        <PayLeafNavbar></PayLeafNavbar>

        <Heading
          fontSize={['2.4rem', '3.2rem']}
          fontWeight={500}
          fontFamily='Qualy'
          mt='2rem'
          mb='1rem'
        >
          PayLeaf for Merchants
        </Heading>

        <Link href='/signup'>
          <Button
            bg='greenPay'
            _hover={{ opacity: 0.9 }}
            color='white'
            border='none'
            paddingX='1.8rem'
            mb='2rem'
          >
            Sign up
          </Button>
        </Link>

        <Grid
          templateColumns='repeat(10, 2fr)'
          gap='1.5rem'
          alignContent={'stretch'}
        >
          <GridItem
            transition={'all 0.5s ease'}
            _hover={{
              transform: 'translateY(-5px)',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.16)',
            }}
            colSpan={[10, 5]}
            bg='white'
            borderRadius='10px'
            px={['1rem', '2rem']}
            py='2rem'
          >
            <Heading fontFamily='Roie' fontSize='1.75rem'>
              What is PayLeaf?
            </Heading>
            <Text mt='.5rem' mb='1.5rem'>
              PayLeaf offers a digital payment method that is easy, convenient,
              safe and comes with an ultra low cost
            </Text>

            <Box fontFamily='Inter'>
              <Text
                fontWeight='500'
                fontSize='1.25rem'
                color='#9498A5'
                my='1rem'
              >
                Easy to register.
              </Text>
              <Text
                fontWeight='500'
                fontSize='1.25rem'
                color='#9498A5'
                my='1rem'
              >
                Works on every mobile phone and tablet.
              </Text>
              <Text
                fontWeight='500'
                fontSize='1.25rem'
                color='#9498A5'
                my='1rem'
              >
                Customers can send various crypto tokens.
              </Text>
              <Text
                fontWeight='500'
                fontSize='1.25rem'
                color='#9498A5'
                my='1rem'
              >
                Support multiple Store Locations
              </Text>
            </Box>

            <Box>
              <Link
                href='https://drive.google.com/uc?export=download&id=1rcF1Avl3DNizOQb6HUvHMJZEyWtyHk_u'
                download
                display='inline-block'
                mt='2rem'
                color='greenPay'
                fontWeight={600}
                _hover={{
                  borderBottom: '2px solid #06792D',
                }}
              >
                <AiOutlineCloudDownload display='inline' /> Download About
                PayLeaf Doc
              </Link>
            </Box>
          </GridItem>

          <GridItem
            transition={'all 0.5s ease'}
            _hover={{
              transform: 'translateY(-5px)',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.16)',
            }}
            colSpan={[10, 5]}
            bg='white'
            borderRadius='10px'
            px={['1rem', '2rem']}
            py='2rem'
          >
            <Heading fontFamily='Roie' fontSize='1.75rem'>
              Benefits for Merchants
            </Heading>
            <Text mt='.5rem' mb='1.5rem'>
              PayLeaf supports in numerous ways to expand and enhance your
              business model. We are your partner for crypto payments.
            </Text>

            <Box fontFamily='Inter'>
              <Text
                fontWeight='500'
                fontSize='1.25rem'
                color='#9498A5'
                my='1rem'
              >
                Ultra low Fees (1-1.2%)
              </Text>
              <Text
                fontWeight='500'
                fontSize='1.25rem'
                color='#9498A5'
                my='1rem'
              >
                Attract additional customers.
              </Text>
              <Text
                fontWeight='500'
                fontSize='1.25rem'
                color='#9498A5'
                my='1rem'
              >
                Safety built in.
              </Text>
              <Text
                fontWeight='500'
                fontSize='1.25rem'
                color='#9498A5'
                my='1rem'
              >
                User friendly Dashboard with all your info.
              </Text>
            </Box>

            <Box>
              <Link
                href='https://drive.google.com/uc?export=download&id=1WvKnZOQJ9ZjN6BXexdwZtqcml97JF_f0'
                download
                display='inline-block'
                mt='2rem'
                color='greenPay'
                fontWeight={600}
                _hover={{
                  borderBottom: '2px solid #06792D',
                }}
              >
                <AiOutlineCloudDownload display='inline' /> Download Benefits
                for Merchants Doc
              </Link>
            </Box>
          </GridItem>

          <GridItem
            transition={'all 0.5s ease'}
            _hover={{
              transform: 'translateY(-5px)',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.16)',
            }}
            colSpan={[10, 10]}
            bg='white'
            borderRadius='10px'
            px={['1rem', '2rem']}
            py='2rem'
          >
            <Heading fontFamily='Roie' fontSize='1.75rem'>
              How does PayLeaf work?
            </Heading>
            <Text mt='.5rem' mb='1.5rem'>
              Merchants enter the USD amount, a QR Code is generated which the
              customer can scan with his/her wallet app on the phone, sending
              the crypto tokens to the merchant's wallet.
            </Text>

            <Image src='images/payleaf-chart.png'></Image>
          </GridItem>

          <GridItem
            transition={'all 0.5s ease'}
            _hover={{
              transform: 'translateY(-5px)',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.16)',
            }}
            colSpan={[10, 5]}
            bg='white'
            borderRadius='10px'
            px={['1rem', '2rem']}
            py='2rem'
          >
            <Heading fontFamily='Roie' fontSize='1.75rem'>
              Benefits for your Customers
            </Heading>
            <Text mt='.5rem' mb='1.5rem'>
              PayLeaf offers a digital payment method that is easy, convenient,
              safe and comes with no customer transaction fee.
            </Text>

            <Box fontFamily='Inter'>
              <Text
                fontWeight='500'
                fontSize='1.25rem'
                color='#9498A5'
                my='1rem'
              >
                Fast & Easy Payment via Phone.
              </Text>
              <Text
                fontWeight='500'
                fontSize='1.25rem'
                color='#9498A5'
                my='1rem'
              >
                Zero Transaction Fees.
              </Text>
              <Text
                fontWeight='500'
                fontSize='1.25rem'
                color='#9498A5'
                my='1rem'
              >
                No need to carry Cash.
              </Text>
              <Text
                fontWeight='500'
                fontSize='1.25rem'
                color='#9498A5'
                my='1rem'
              >
                Future Benefits for PayLeaf Users.
              </Text>
            </Box>

            <Box>
              <Link
                href='https://drive.google.com/uc?export=download&id=1HI7AmLNtO4SRSlblYzY2LzaoLnh3k5bh'
                download
                display='inline-block'
                mt='2rem'
                color='greenPay'
                fontWeight={600}
                _hover={{
                  borderBottom: '2px solid #06792D',
                }}
              >
                <AiOutlineCloudDownload display='inline' /> Download Customer
                Benefits Doc
              </Link>
            </Box>
          </GridItem>

          <GridItem
            colSpan={[10]}
            px={['1rem', '2rem']}
            mt='2rem'
            textAlign='center'
          >
            <Text fontFamily='Roie' fontSize='1.2rem' my='1.5rem'>
              PayLeaf is created by the Team of{' '}
              <Link
                href='https://www.stonedapecrew.com'
                target='_blank'
                textDecor='underline'
              >
                Stoned Ape Crew
              </Link>
              .
            </Text>
            <Text>
              <Link
                href='https://drive.google.com/uc?export=download&id=1JCeW9iJI6DgN5LwAvXAP0vqkqDG2rZHC'
                download
                fontWeight={600}
                borderBottom='1px solid #262626'
                _hover={{
                  borderBottom: '2px solid #262626',
                }}
              >
                <AiOutlineCloudDownload display='inline' /> Cannabis and Retail
                Partnership Opportunities
              </Link>
            </Text>
            <Text mt='.5rem'>
              <Link
                href='https://drive.google.com/uc?export=download&id=1uJJqog18RnckREx27-sDnlivS-aJL96N'
                download
                fontWeight={600}
                borderBottom='1px solid #262626'
                _hover={{
                  borderBottom: '2px solid #262626',
                }}
              >
                <AiOutlineCloudDownload display='inline' /> Why Partner with
                Stoned Ape Crew
              </Link>
            </Text>
          </GridItem>

          <GridItem
            colSpan={[10]}
            bg='white'
            borderRadius='10px'
            mt='3rem'
            px={['1rem', '2rem']}
            py='2rem'
          >
            <Flex direction={['column', 'row']}>
              <Heading
                fontFamily='Roie'
                display={['block', 'none']}
                paddingLeft='1rem'
                mb='2rem'
              >
                Any Questions?
              </Heading>

              <Accordion
                defaultIndex={[0]}
                allowMultiple
                width={['100%', '60%']}
              >
                {faq.map((f, i) => (
                  <AccordionItem
                    key={f.question}
                    borderBottom={
                      i === faq.length - 1 ? 'none' : '1px solid #ddd'
                    }
                  >
                    <h2>
                      <AccordionButton>
                        <Box flex='1' textAlign='left'>
                          <i>{f.question}</i>
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4}>{f.answer}</AccordionPanel>
                  </AccordionItem>
                ))}
              </Accordion>
              {/* <Spacer/> */}
              <Box position='relative' width='40%' display={['none', 'block']}>
                <Heading
                  fontFamily='Roie'
                  position='absolute'
                  top='50%'
                  left='50%'
                  translateX='-50%'
                  transform='translate(-50%, -50%)'
                >
                  Any Questions?
                </Heading>
              </Box>
            </Flex>
          </GridItem>
        </Grid>
      </Container>
    </Box>
  )
}
